module.exports = __webpack_public_path__ + "img/girl question.6420fc6a.png";